<template>
	<div :class="classes" v-html="codePoint" />
</template>

<script lang="ts">
import { CSSClasses } from '@/common/types';
import { Component, Vue, Prop } from 'vue-facing-decorator';

export declare type EmojiSize = 'sm' | 'md' | 'lg' | 'xl';

@Component
export default class Emoji extends Vue {
	@Prop({ required: true })
	codePoint: string;

	@Prop({ default: false, type: Boolean })
	inline: boolean;

	@Prop({ default: 'md' })
	size: EmojiSize;

	get classes(): CSSClasses {
		const classes:CSSClasses = {
			'emji': true,
			'inline': this.inline
		};

		classes[this.size] = true;

		return classes;
	}
}
</script>

<style lang="scss">
.emji {
	font-family: "Noto Color Emoji";  /*, "Twemoji Mozilla", Apple Color Emoji, "Segoe UI Emoji", "EmojiOne Color";*/
	font-variant-emoji: emoji;

	&.sm {
		@apply text-base;
	}

	&.md {
		@apply text-lg;
	}

	&.lg {
		@apply text-xl;
	}

	&.xl {
		@apply text-2xl;
	}
}
</style>
